module.exports = __webpack_public_path__ + "img/7bfc995.jpg";